export default __webpack_public_path__ + "static/media/backArr.63a2cc3b.svg";